<template>
  <b-form class="needs-validation" @submit.prevent="submitForm">
    <b-card no-body>
      <b-card-header>
        <b-card-title>Ruangan</b-card-title>
        <b-card-title class="text-primary">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="secondary" class="btn-icon"
            :to="{ name: 'bRuangan' }">
            <feather-icon icon="ArrowLeftIcon" />
          </b-button>
        </b-card-title>
      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col md="10" offset-md="1">
            <b-form-group label="Nama PD/UKPD Pemilik KIB C" label-for="kolok" label-class="pb-0 pt-0">
              <b-overlay :show="isLoadKolok" variant="light" opacity="0.85" blur="2px" rounded="sm">
                <v-select id="kolok" v-model="kolok" :options="kolokOptions" label="text"
                  :disabled="action == 'update' || action == 'detail'" @input="inputKolok" />
              </b-overlay>
            </b-form-group>

            <b-form-group label="Pencarian BMD" label-for="register" label-class="pb-0 pt-0">
              <b-overlay :show="isLoadRegister" variant="light" opacity="0.85" blur="2px" rounded="sm">
                <v-select id="register" v-model="register" :options="registerOptions" label="text"
                  :disabled="action == 'update' || action == 'detail'" @search="searchRegister" @input="inputRegister" />
              </b-overlay>
            </b-form-group>
            <b-row>
              <b-col v-for="(item, index) of field" :key="index" :cols="item.col || '12'">
                <b-form-group :label="item.label" :label-for="item.id" label-class="pb-0 pt-0">
                  <b-form-input :id="item.id" :value="item.value" disabled />
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group label="Lantai" label-class="pb-0 pt-0" label-for="lantai">
              <b-form-select v-model="ruangan.lantai" :options="lantaiOptions" :disabled="action == 'detail'"
                @input="inputLantai" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card v-if="register.value && ruangan.lantai" no-body>
      <b-card-header>
        <b-card-title />
        <b-card-title v-if="$can('Buat', 'b-ruangan') && ruangan.lantai" class="text-primary">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
            @click="openModal({ idJenisRuangan: null, namaJenisRuangan: '-- Pilih Salah Satu --' })">
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="align-middle">Tambah</span>
          </b-button>
        </b-card-title>
      </b-card-header>
      <b-card-body>
        <b-row>
          <vue-good-table :columns="tableValues.columns" :rows="tableValues.rows" :total-rows="tableValues.totalRecords"
            :is-loading="tableValues.isLoading" mode="remote">
            <template slot="table-row" slot-scope="props">
              <!-- Column: aksi -->
              <span v-if="props.column.field === 'aksi'">
                <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                  <template v-slot:button-content>
                    <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                  </template>
                  <b-dropdown-item v-for="(item, index) of getAksi()" :key="index" @click="item.clickAksi({
                    idRuangan: props.row.id,
                    idJenisRuangan: props.row.jenis_ruangan_id,
                    namaJenisRuangan: props.row.jenis_ruangan_nama,
                    namaRuangan: props.row.nama_ruangan,
                    kolok: props.row.kolok,
                  })">
                    <feather-icon :icon="item.icon" class="mr-50" />
                    <span>{{ item.buttonLabel }}</span>
                  </b-dropdown-item>
                </b-dropdown>
              </span>

              <!-- Column: Common -->
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

            <!-- pagination -->
            <template slot="pagination-bottom">
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap"> Menampilkan 1 hingga </span>
                  <span class="text-nowrap">
                    dari {{ tableValues.totalRecords }} entri
                  </span>
                </div>
              </div>
            </template>
          </vue-good-table>
        </b-row>
      </b-card-body>
      <ModalRuangan
        :props-modal="{ ruangan, lantaiOptions, register: register.value, kolok: kolok.value, modal, inputLantai }" />
    </b-card>
  </b-form>
</template>

<script>
import {
  ref, computed, watchEffect, watch,
} from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { VueGoodTable } from 'vue-good-table'
import apiMaster from '@/composables/master'
import apiGedung from '@/composables/b/gedung'
import apiLantai from '@/composables/master/lantai'
import apiRuangan from '@/composables/b/ruangan'
import ModalRuangan from '@/views/b/ruangan/components/ModalRuangan.vue'
import { propsBoolean, propsObject, propsString } from '@/utils/propsTipeData'
import helper from '@/libs/helper'

export default {
  setup(props, context) {
    const g = context.root
    const { tahunNow } = helper
    const registerDefVal = { text: '-- Pilih / Ketik Pencarian (Alamat/Nama Spesifikasi) --', value: null };
    const kolok = ref(helper.defaultValue)
    const register = ref(registerDefVal)
    const kodeNamaBarang = ref('')
    const ruangan = ref({
      lantai: null,
      jenisRuangan: helper.defaultValue,
      namaRuangan: '',
      idRuangan: null,
    })
    const tableValues = ref({
      rows: [],
      columns: [
        {
          label: 'Aksi',
          field: 'aksi',
          width: '1%',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Kode QR',
          field: 'kode_qr',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Guid ID',
          field: 'guid_aset',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Kolok',
          field: 'kolok_gedung',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Alamat Register',
          field: 'alamat',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Kode Barang',
          field: 'kobar_108',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Nama Barang',
          field: 'nabar_108',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Nama Spesifikasi Barang',
          field: 'nm_spesifikasi_barang',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Lantai',
          field: 'lantai',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Jenis Ruangan',
          field: 'jenis_ruangan_nama',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Ruangan',
          field: 'nama_ruangan',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
      ],
      totalRecords: 0,
      isLoading: false,
    })
    const tempData = ref({})

    const kolokOptions = ref([helper.defaultValue])
    const registerOptions = ref([registerDefVal])
    const lantaiOptions = ref([helper.defaultValue])
    const modal = ref({
      toggle: false,
      action: 'Tambah',
    })

    const isLoadKolok = ref(false)
    const isLoadRegister = ref(false)

    watchEffect(() => {
      if (kolokOptions.value.length > 1) {
        tempData.value = props.dataDetail
      }
    })

    const field = computed(() => ([
      {
        label: 'Kode dan Nama Barang',
        id: 'kodeNamaBarang',
        value: kodeNamaBarang.value,
      },
    ]))

    const getPdUkpd = (searchPdUpd = '') => {
      const params = {
        tahun: tahunNow,
        cari: searchPdUpd,
      }
      return apiMaster.getPdUpd(g, params)
    }

    const getRegister = (kolokVal = null, cari = '') => {
      const data = {
        filter_kolok: kolokVal,
        limit: 20,
        cari,
      }
      return apiGedung.getGedung(g, data)
    }

    const getLantai = () => apiLantai.getLantai(g)

    const initData = async () => {
      isLoadKolok.value = true

      const [resultKolok, resultLantai] = await Promise.all([
        getPdUkpd(),
        getLantai(),
      ])

      resultKolok.unshift(helper.defaultValue)
      kolokOptions.value = resultKolok

      lantaiOptions.value = [helper.defaultValue, ...resultLantai.rows]

      isLoadKolok.value = false
    }

    initData()

    const fieldForm = {
      kolok,
      register,
      ruangan,
    }

    const setRegisterOptions = async kolokVal => {
      isLoadRegister.value = true

      const result = await getRegister(kolokVal)

      registerOptions.value = [
        registerDefVal,
        ...result.rows.map(item => {
          const additional = item.nm_spesifikasi_barang ? ` :: ${item.nm_spesifikasi_barang}` : ''
          return {
            text: `${item.noreg_108} :: ${item.alamat}${additional}`,
            value: item.guid_aset,
            ...item,
          }
        }),
      ]

      isLoadRegister.value = false
    }

    watch(tempData, () => {
      const index = kolokOptions.value.findIndex(item => item.value == tempData.value.kolok)
      if (index >= 0) {
        kolok.value = kolokOptions.value[index]
        if (kolokOptions.value[index].value) {
          setRegisterOptions(kolokOptions.value[index].value)
        }
      } else kolok.value = helper.defaultValue
    })

    const inputKolok = e => {
      register.value = registerDefVal
      kodeNamaBarang.value = ''
      if (e) {
        if (e.value) {
          setRegisterOptions(e.value)
        } else registerOptions.value = [registerDefVal]
      } else {
        kolok.value = helper.defaultValue
        registerOptions.value = [registerDefVal]
      }
    }

    const inputRegister = async e => {
      if (e) {
        if (e.value) kodeNamaBarang.value = `${e.kobar_108} :: ${e.nabar_108}`
        else kodeNamaBarang.value = ''
      } else {
        register.value = registerDefVal
        kodeNamaBarang.value = ''
      }
      ruangan.value.lantai = null
    }

    const searchRegister = async search => {
      const result = await getRegister(kolok.value.value, search)

      registerOptions.value = [
        registerDefVal,
        ...result.rows.map(item => {
          const additional = item.nm_spesifikasi_barang ? ` :: ${item.nm_spesifikasi_barang}` : ''
          return {
            text: `${item.noreg_108} :: ${item.alamat}${additional}`,
            value: item.guid_aset,
            ...item,
          }
        }),
      ]
    }

    const { validateState, validateState2 } = helper

    const inputLantai = async () => {
      if (ruangan.value.lantai) {
        tableValues.value.isLoading = true
        const params = {
          filter_kolok: g.$cookies.get('kolok') || kolok.value.value,
          limit: 10000000,
          start: 0,
          filter_gedung: register.value.value,
          filter_lantai: ruangan.value.lantai,
        }
        const result = await apiRuangan.getRuangan(g, params)
        tableValues.value.rows = result.rows
        tableValues.value.isLoading = false
      } else {
        tableValues.value.rows = []
      }
    }

    const hapusRuangan = ({ idRuangan, kolok: kolokVal }) => {
      g.$swal({
        title: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya hapus',
        cancelButtonText: 'Batal',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async res => {
        if (res.value) {
          const result = await apiRuangan.deleteRuangan(g, { ruangan_id: idRuangan, kolok: kolokVal })
          if (result.isSuccess) inputLantai()
        }
      })
    }

    const openModal = ({
      idRuangan = null, idJenisRuangan, namaJenisRuangan, namaRuangan = '', action = 'Tambah',
    }) => {
      ruangan.value = {
        ...ruangan.value,
        jenisRuangan: {
          text: namaJenisRuangan,
          value: idJenisRuangan,
        },
        namaRuangan,
        idRuangan,
      }
      modal.value = {
        action, toggleModal: !modal.value.toggleModal,
      }
    }

    return {
      defaultValue: helper.defaultValue,
      isLoadKolok,
      isLoadRegister,
      kodeNamaBarang,
      tableValues,

      ...fieldForm,

      field,
      kolokOptions,
      registerOptions,
      lantaiOptions,
      modal,

      validateState,
      inputKolok,
      inputRegister,
      searchRegister,
      validateState2,
      hapusRuangan,
      openModal,
      inputLantai,
    }
  },
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    VueGoodTable,
    ModalRuangan,
  },
  props: {
    dataDetail: propsObject,
    action: propsString,
    isGetDetailVal: propsBoolean,
  },
  methods: {
    getAksi() {
      const listAksi = []

      if (this.$can('Ubah', 'b-ruangan')) {
        listAksi.unshift({
          clickAksi: payload => {
            this.openModal({ ...payload, action: 'Ubah' })
          },
          buttonLabel: 'Update',
          icon: 'Edit2Icon',
        })
      }
      if (this.$can('Hapus', 'b-ruangan')) {
        listAksi.push({
          clickAksi: payload => {
            this.hapusRuangan({ idRuangan: payload.idRuangan, kolok: payload.kolok })
          },
          buttonLabel: 'Hapus',
          icon: 'TrashIcon',
        })
      }

      return listAksi
    },
  },
}
</script>
<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
